import { request } from './http';

export async function getVerificationQuestions(filters = {}) {
    const queryParams = new URLSearchParams();
    if (filters.CompanyID) queryParams.append('CompanyID', filters.CompanyID);
    if (filters.ComplianceElementID) queryParams.append('ComplianceElementID', filters.ComplianceElementID);
    if (filters.ComplianceAspectID) queryParams.append('ComplianceAspectID', filters.ComplianceAspectID);
    if (filters.AuditScopeID) queryParams.append('AuditScopeID', filters.AuditScopeID);
    if (filters.QuestionBankID) queryParams.append('QuestionBankID', filters.QuestionBankID);
    if (filters.Active !== undefined) queryParams.append('Active', filters.Active);
    const queryString = queryParams.toString();
    return request(`/verifications/questions${queryString ? '?' + queryString : ''}`);
  }

export async function getVerificationQuestion(id) {
    return request(`/verifications/questions/${id}`);
  }

export async function createVerificationQuestion(questionData) {
    return request('/verifications/questions', {
      method: 'POST',
      body: JSON.stringify(questionData),
    });
  }

export async function updateVerificationQuestion(id, questionData) {
    return request(`/verifications/questions/${id}`, {
      method: 'PUT',
      body: JSON.stringify(questionData),
    });
  }

export async function deleteVerificationQuestion(id) {
    return request(`/verifications/questions/${id}`, {
      method: 'DELETE',
    });
  }

export async function getPreAuditQuestionnaires(filters = {}) {
    const queryParams = new URLSearchParams();
    if (filters.SiteID) queryParams.append('SiteID', filters.SiteID);
    if (filters.Year) queryParams.append('Year', filters.Year);
    if (filters.Status) queryParams.append('Status', filters.Status);
    const queryString = queryParams.toString();
    return request(`/verifications/pre-audit-questionnaires${queryString ? '?' + queryString : ''}`);
  }

export async function getPreAuditQuestionnaire(id) {
    return request(`/verifications/pre-audit-questionnaires/${id}`);
  }

export async function generateAnnualQuestionnaires(year) {
    return request('/verifications/pre-audit-questionnaires/generate-annual', {
      method: 'POST',
      body: JSON.stringify({ year }),
    });
  }

export async function generateAnnualQuestionnairesTest(year, companyIds = []) {
    return request('/verifications/pre-audit-questionnaires/generate-annual-test', {
      method: 'POST',
      body: JSON.stringify({ year, companyIds }),
    });
  }

export async function triggerAnnualQuestionnaireGeneration(year = null) {
    return request('/verifications/pre-audit-questionnaires/trigger-annual-generation', {
      method: 'POST',
      body: JSON.stringify({ year }),
    });
  }

export async function createPreAuditQuestionnaire(questionnaireData) {
    return request('/verifications/pre-audit-questionnaires', {
      method: 'POST',
      body: JSON.stringify(questionnaireData),
    });
  }

export async function updatePreAuditQuestionnaire(id, questionnaireData) {
    return request(`/verifications/pre-audit-questionnaires/${id}`, {
      method: 'PUT',
      body: JSON.stringify(questionnaireData),
    });
  }

export async function deletePreAuditQuestionnaire(id) {
    return request(`/verifications/pre-audit-questionnaires/${id}`, {
      method: 'DELETE',
    });
  }

export async function submitPreAuditQuestionnaire(id) {
    return request(`/verifications/pre-audit-questionnaires/${id}/submit`, {
      method: 'POST',
    });
  }

export async function getQuestionnairePdfUrl(id) {
    return request(`/verifications/pre-audit-questionnaires/${id}/pdf`);
  }

export function getQuestionnaireBlankPdfPath(id, sortBy) {
    const base = `/verifications/pre-audit-questionnaires/${id}/pdf/blank`;
    if (sortBy === 'element' || sortBy === 'aspect') {
      return `${base}?sortBy=${sortBy}`;
    }
    return base;
  }

export async function regenerateQuestionnairePdf(id) {
    return request(`/verifications/pre-audit-questionnaires/${id}/regenerate-pdf`, {
      method: 'POST',
    });
  }

export async function getQuestionnaireGoverningBodies(questionnaireId) {
    return request(`/verifications/pre-audit-questionnaires/${questionnaireId}/governing-bodies`);
  }

export async function setQuestionnaireGoverningBodies(questionnaireId, governingBodyIDs) {
    return request(`/verifications/pre-audit-questionnaires/${questionnaireId}/governing-bodies`, {
      method: 'PUT',
      body: JSON.stringify({ GoverningBodyIDs: governingBodyIDs }),
    });
  }

export async function setQuestionnaireQuestionsRegulations(questionnaireId, { addRegulationIds, removeRegulationIds }) {
    return request(`/verifications/pre-audit-questionnaires/${questionnaireId}/questions-regulations`, {
      method: 'PUT',
      body: JSON.stringify({ addRegulationIds: addRegulationIds || [], removeRegulationIds: removeRegulationIds || [] }),
    });
  }

export async function setApplicabilityReviewRegulations(applicabilityReviewId, regulationIds) {
    return request(`/verifications/applicability-reviews/${applicabilityReviewId}/regulations`, {
      method: 'PUT',
      body: JSON.stringify({ regulationIds: regulationIds || [] }),
    });
  }

export async function setQuestionRegulations(questionId, regulationIds) {
    return request(`/verifications/questions/${questionId}/regulations`, {
      method: 'PUT',
      body: JSON.stringify({ regulationIds: regulationIds || [] }),
    });
  }

export const verificationQuestionsApi = {
  getVerificationQuestions,
  getVerificationQuestion,
  createVerificationQuestion,
  updateVerificationQuestion,
  deleteVerificationQuestion,
  getPreAuditQuestionnaires,
  getPreAuditQuestionnaire,
  generateAnnualQuestionnaires,
  generateAnnualQuestionnairesTest,
  triggerAnnualQuestionnaireGeneration,
  createPreAuditQuestionnaire,
  updatePreAuditQuestionnaire,
  deletePreAuditQuestionnaire,
  submitPreAuditQuestionnaire,
  getQuestionnairePdfUrl,
  getQuestionnaireBlankPdfPath,
  regenerateQuestionnairePdf,
  getQuestionnaireGoverningBodies,
  setQuestionnaireGoverningBodies,
  setQuestionnaireQuestionsRegulations,
  setApplicabilityReviewRegulations,
  setQuestionRegulations,
};

